import { LoadingIndicator } from '@/components/loadingIndicator';
import React from 'react';
import { lazyLoad } from 'utils/loadable';

export const TokensPage = lazyLoad(
  () => import('./index'),
  (module) => module.TokensPage,
  { fallback: <LoadingIndicator fullPageHeight /> }
);
